import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../../../components/global/Button';

const propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      asset_image: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  ),
  selectedAssetId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

const PreviousDesignPicker = ({ assets = [], selectedAssetId, onSelect }) => {
  return (
    <div className="marketing-material-previous-designs">
      {assets.map(asset => (
        <Button
          key={asset.id}
          btnStyle="reset"
          className={classNames('marketing-material-previous-design-item', {
            'is-selected': asset.id === selectedAssetId,
          })}
          onClick={() => onSelect(asset)}
        >
          <img src={asset.asset_image?.url} alt={asset.name} />
          <span className="text-sm text-truncate">{asset.name}</span>
        </Button>
      ))}
    </div>
  );
};

PreviousDesignPicker.propTypes = propTypes;

export default PreviousDesignPicker;
